import { render, staticRenderFns } from "./studyplan-order-info.vue?vue&type=template&id=7323dbdf&scoped=true"
import script from "./studyplan-order-info.vue?vue&type=script&lang=js"
export * from "./studyplan-order-info.vue?vue&type=script&lang=js"
import style0 from "./studyplan-order-info.vue?vue&type=style&index=0&id=7323dbdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7323dbdf",
  null
  
)

export default component.exports